import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  serializerodflzzf6s3fp as serializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
} from '../builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from './InlineClassDescriptor.mjs';
import {
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw,
  UInt1hthisrv6cndi as UInt,
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ULongSerializerClass;
function ULongSerializer() {
  if (ULongSerializerClass === VOID) {
    class $ {
      constructor() {
        ULongSerializer_instance = this;
        this.h29_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer(Companion_instance));
      }
      b1n() {
        return this.h29_1;
      }
      i29(encoder, value) {
        var tmp = encoder.z1s(this.h29_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.t1s(tmp$ret$0);
      }
      c1n(encoder, value) {
        return this.i29(encoder, value instanceof ULong() ? value.rv_1 : THROW_CCE());
      }
      j29(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.p1r(this.h29_1).j1r();
        return _ULong___init__impl__c78o9k(this_0);
      }
      d1n(decoder) {
        return new (ULong())(this.j29(decoder));
      }
    }
    initMetadataForObject($, 'ULongSerializer', VOID, VOID, [KSerializer()]);
    ULongSerializerClass = $;
  }
  return ULongSerializerClass;
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new (ULongSerializer())();
  return ULongSerializer_instance;
}
var UIntSerializerClass;
function UIntSerializer() {
  if (UIntSerializerClass === VOID) {
    class $ {
      constructor() {
        UIntSerializer_instance = this;
        this.k29_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_0(IntCompanionObject_instance));
      }
      b1n() {
        return this.k29_1;
      }
      l29(encoder, value) {
        var tmp = encoder.z1s(this.k29_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.s1s(tmp$ret$0);
      }
      c1n(encoder, value) {
        return this.l29(encoder, value instanceof UInt() ? value.gv_1 : THROW_CCE());
      }
      m29(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.p1r(this.k29_1).i1r();
        return _UInt___init__impl__l7qpdl(this_0);
      }
      d1n(decoder) {
        return new (UInt())(this.m29(decoder));
      }
    }
    initMetadataForObject($, 'UIntSerializer', VOID, VOID, [KSerializer()]);
    UIntSerializerClass = $;
  }
  return UIntSerializerClass;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new (UIntSerializer())();
  return UIntSerializer_instance;
}
var UByteSerializerClass;
function UByteSerializer() {
  if (UByteSerializerClass === VOID) {
    class $ {
      constructor() {
        UByteSerializer_instance = this;
        this.n29_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_1(ByteCompanionObject_instance));
      }
      b1n() {
        return this.n29_1;
      }
      o29(encoder, value) {
        var tmp = encoder.z1s(this.n29_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.q1s(tmp$ret$0);
      }
      c1n(encoder, value) {
        return this.o29(encoder, value instanceof UByte() ? value.vu_1 : THROW_CCE());
      }
      p29(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.p1r(this.n29_1).g1r();
        return _UByte___init__impl__g9hnc4(this_0);
      }
      d1n(decoder) {
        return new (UByte())(this.p29(decoder));
      }
    }
    initMetadataForObject($, 'UByteSerializer', VOID, VOID, [KSerializer()]);
    UByteSerializerClass = $;
  }
  return UByteSerializerClass;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new (UByteSerializer())();
  return UByteSerializer_instance;
}
var UShortSerializerClass;
function UShortSerializer() {
  if (UShortSerializerClass === VOID) {
    class $ {
      constructor() {
        UShortSerializer_instance = this;
        this.q29_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_2(ShortCompanionObject_instance));
      }
      b1n() {
        return this.q29_1;
      }
      r29(encoder, value) {
        var tmp = encoder.z1s(this.q29_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.r1s(tmp$ret$0);
      }
      c1n(encoder, value) {
        return this.r29(encoder, value instanceof UShort() ? value.cw_1 : THROW_CCE());
      }
      s29(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.p1r(this.q29_1).h1r();
        return _UShort___init__impl__jigrne(this_0);
      }
      d1n(decoder) {
        return new (UShort())(this.s29(decoder));
      }
    }
    initMetadataForObject($, 'UShortSerializer', VOID, VOID, [KSerializer()]);
    UShortSerializerClass = $;
  }
  return UShortSerializerClass;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new (UShortSerializer())();
  return UShortSerializer_instance;
}
//region block: exports
export {
  UByteSerializer_getInstance as UByteSerializer_getInstance29ovrhqybz59q,
  UIntSerializer_getInstance as UIntSerializer_getInstance3tg9r9shlxhbj,
  ULongSerializer_getInstance as ULongSerializer_getInstance6th9fj1q70m2,
  UShortSerializer_getInstance as UShortSerializer_getInstance3bith9k7xv4n8,
};
//endregion

//# sourceMappingURL=ValueClasses.mjs.map
